import { createReducer, on } from '@ngrx/store';
import { spendingTrendsInitialState, SpendingTrendsState } from '@store/states/spending-trends.state';
import { spendingTrendsActions } from '@store/actions/spending-trends.actions';

export const spendingTrendsReducer = createReducer(
  spendingTrendsInitialState,
  on(
    spendingTrendsActions.tabSelected,
    (state: SpendingTrendsState, { tab }): SpendingTrendsState => ({
      ...state,
      tab,
    })
  ),
  on(
    spendingTrendsActions.filterSpending,
    (state: SpendingTrendsState, { filter }): SpendingTrendsState => ({
      ...state,
      spending: {
        ...state.spending,
        filter: {
          ...filter,
        },
      },
    })
  ),
  on(
    spendingTrendsActions.filterConsumption,
    (state: SpendingTrendsState, { filter }): SpendingTrendsState => ({
      ...state,
      consumption: {
        ...state.consumption,
        filter: {
          ...filter,
        },
      },
    })
  ),
  on(
    spendingTrendsActions.setSpending,
    (state: SpendingTrendsState, { current, previous }): SpendingTrendsState => ({
      ...state,
      spending: {
        ...state.spending,
        previous: [...previous],
        current: [...current],
      },
    })
  ),
  on(
    spendingTrendsActions.setPreviousConsumption,
    (state: SpendingTrendsState, { data }): SpendingTrendsState => ({
      ...state,
      consumption: {
        ...state.consumption,
        previous: [...data],
      },
    })
  ),
  on(
    spendingTrendsActions.setCurrentConsumption,
    (state: SpendingTrendsState, { data }): SpendingTrendsState => ({
      ...state,
      consumption: {
        ...state.consumption,
        current: [...data],
      },
    })
  )
);
